import { Col, Row } from 'react-bootstrap';
import UniversalInput from 'components/global/UniversalInput';
import { DEAL_TYPE_OPTIONS, INVESTMENT_STAGE_OPTIONS } from 'components/global/DealForm/_helpers/dealForm.consts';
import { $form } from 'signals/global.signals';
import getSelectValue from 'utils/getSelectValue';
import { ACQUISITION_TYPES, DEBT_RAISE_TYPES } from 'constants/globalConstants';

const FounderDealForm = () => {
  return (
  <Row>
    <Col sm={12} md={12}>
      <UniversalInput
        name="name"
        label="Name"
        className="mb-32"
      />
    </Col>
    <h6 className="text-gray-400 fw-bold mb-16">Deal Details</h6>
    <Col sm={12} md={6}>
      <UniversalInput
        name="investmentStage"
        label="Investment Stage"
        className="mb-16"
        type="select"
        // Todo: Not sure why we need to do it this way on just this input but it is only working this way for now
        value={INVESTMENT_STAGE_OPTIONS.find((option) => option.value === getSelectValue($form.value.investmentStage))}
        options={INVESTMENT_STAGE_OPTIONS}
      />
    </Col>
    {getSelectValue($form.value.investmentStage) !== 'Acquisition' && (
      <Col sm={12} md={6}>
        <UniversalInput
          name="typeOfRaise"
          label="Type of Raise"
          className="mb-16"
          type="select"
          value={DEAL_TYPE_OPTIONS.find((option) => option.value === getSelectValue($form.value.typeOfRaise))}
          options={DEAL_TYPE_OPTIONS}
        />
      </Col>
    )}
    <Col sm={12} md={6}>
      <UniversalInput
        name="fundingDate"
        label="Closing Date"
        className="mb-16"
        type="date"
        required
      />
    </Col>
    <Col sm={12} md={6}>
      <UniversalInput
        name="preMoneyValuation"
        label={getSelectValue($form.value.investmentStage) === 'Acquisition' ? 'Purchase Price' : 'Pre-Money Valuation'}
        className="mb-16"
        type="money"
        required
      />
    </Col>
    <Col sm={12} md={6}>
      {getSelectValue($form.value.investmentStage) !== 'Acquisition' && (
        <UniversalInput
          name="currentRaiseSize"
          label="Current Raise Size"
          className="mb-16"
          type="money"
          required
          disabled={getSelectValue($form.value.investmentStage) === 'Acquisition'}
          placeholder={getSelectValue($form.value.investmentStage) === 'Acquisition' ? 'Not Applicable for acquisition deals' : ''}
        />
      )}
    </Col>
    {getSelectValue($form.value.investmentStage) !== 'Acquisition' && (
      <Col sm={12} md={6}>
        <UniversalInput
          name="minimumInvestment"
          label="Minimum Investment"
          className="mb-16"
          type="money"
          required
          disabled={getSelectValue($form.value.investmentStage) === 'Acquisition'}
          placeholder={getSelectValue($form.value.investmentStage) === 'Acquisition' ? 'Not Applicable for acquisition deals' : ''}
        />
      </Col>
    )}
    {(ACQUISITION_TYPES.includes(getSelectValue($form.value.typeOfRaise)) || ACQUISITION_TYPES.includes(getSelectValue($form.value.investmentStage))) && (
      <>
        {/* eslint-disable-next-line react/jsx-no-useless-fragment */}
        {getSelectValue($form.value.investmentStage) !== 'Acquisition' && (
          <Col sm={12} md={6}>
            <UniversalInput
              type="money"
              name="amountPreviouslyRaised"
              label="Amount Previously Raised"
              className="mb-16"
              required
              disabled={getSelectValue($form.value.investmentStage) === 'Acquisition'}
              placeholder={getSelectValue($form.value.investmentStage) === 'Acquisition' ? 'Not Applicable for acquisition deals' : ''}
            />
          </Col>
        )}
      </>
    )}
    {getSelectValue($form.value.investmentStage) !== 'Acquisition' && (
      <Col sm={12} md={6}>
        <UniversalInput
          type="money"
          name="amountCommitted"
          label="Amount Committed"
          className="mb-16"
        />
      </Col>
    )}
    {DEBT_RAISE_TYPES.includes(getSelectValue($form.value.typeOfRaise)) && (
      <>
        <h6 className="text-gray-400 fw-bold mb-16 mt-16">Debt Terms</h6>
        <Col sm={12} md={6}>
          <UniversalInput
            name="cap"
            label="Cap"
            className="mb-16"
          />
        </Col>
        <Col sm={12} md={6}>
          <UniversalInput
            name="interestRate"
            label="Interest Rate"
            className="mb-16"
          />
        </Col>
        <Col sm={12} md={6}>
          <UniversalInput
            name="discountPercent"
            label="Discount Percent"
            className="mb-16"
          />
        </Col>
      </>
    )}
    {getSelectValue($form.value.investmentStage) !== 'Acquisition' && (
      <Col sm={12} md={12}>
        <UniversalInput
          name="usesOfCapital"
          label="Uses of Capital"
          type="textarea"
          required
        />
      </Col>
    )}
    <Col sm={12} md={12}>
      <UniversalInput
        name="dealTerms"
        label="Additional Deal Terms"
        type="textarea"
        placeholder="Provide any additional deal terms or notes here."
        
      />
    </Col>
  </Row>
);
}

export default FounderDealForm;
